import { PresencePerformance } from './PresencePerformance';
import { useSyncExternalStore } from 'react';
import { demoBots, type DemoPresence, type DemoView, type DemoPlayback } from '../../collaboration/demoBots';
import { SelectDropdown } from '../Dropdown';
import { Icon } from '../Icon';
import { plural, t } from '../../i18n/I18n';

/** Persistent, read-only rehearsal: freeze a frame or keep everyone in the view being inspected. A chat run's presence has no script to rehearse. */
export function DemoControls(props: { demo: DemoPresence; placement?: 'stage' | 'chat' }) {
  return props.demo.scripted ? <DemoControlsBar {...props} /> : null;
}

function DemoControlsBar({ demo, placement = 'stage' }: { demo: DemoPresence; placement?: 'stage' | 'chat' }) {
  const state = useSyncExternalStore(demo.subscribePlayback, demo.getPlayback);
  return <div className={'collab-demo-controls' + (placement === 'chat' ? ' is-chat' : '')} aria-label={t('#DemoControlsLabel')}>
    {placement === 'stage' && <PresencePerformance />}
    <span className="collab-demo-label">{t('#DemoControlsDemo')}</span>
    <SelectDropdown label={t('#DemoControlsViews')} value={state.view} options={[
      { value: 'auto', label: t('#DemoControlsViewAuto') }, { value: 'floor', label: t('#DemoControlsViewFloor') },
      { value: 'orbit', label: t('#DemoControlsViewOrbit') }, { value: 'walk', label: t('#DemoControlsViewWalk') },
    ]} onChange={view => demo.configure({ view: view as DemoView })} />
    <SelectDropdown label={t('#DemoControlsSelections')} value={state.selection} options={[
      { value: 'auto', label: t('#DemoControlsSelectionAuto') }, { value: 'item', label: t('Items') },
      { value: 'wall', label: t('Walls') }, { value: 'opening', label: t('Openings') },
    ]} onChange={selection => demo.configure({ selection: selection as DemoPlayback['selection'] })} />
    <SelectDropdown label={t('#DemoControlsCrowd')} value={String(state.crowd)} options={[
      { value: '6', label: plural('#DemoControlsParticipants', 6) }, { value: '20', label: plural('#DemoControlsParticipants', 20) }, { value: '50', label: plural('#DemoControlsParticipants', 50) },
    ]} onChange={count => demo.setCrowd(Number(count))} />
    <button type="button" aria-label={state.paused ? t('#DemoControlsResumeSimulation') : t('#DemoControlsPauseSimulation')} aria-pressed={state.paused}
      onClick={() => demo.configure({ paused: !state.paused })}>{state.paused ? t('#DemoControlsResume') : t('Pause')}</button>
    <button type="button" className="collab-demo-close" aria-label={t('#DemoControlsClose')} onClick={() => demoBots.set(false)}><Icon name="closeX" size={16} /></button>
  </div>;
}
